/**
 * 计算器注册中心
 * 统一管理所有计算器的元数据、schema配置、路由信息
 * 替代原 calc_list_new.js + calc_roles.js
 */

// ── 职业身份列表 ──
export const CALC_ROLES = [
	{ label: '全部', value: '', icon: '全', desc: '所有计算器', calc_types: [] },
	{ label: '设计师', value: 'designer', icon: '设', desc: '设计费 / 勘察费', calc_types: ['zero', 'five'] },
	{ label: '监理工程师', value: 'supervisor', icon: '监', desc: '监理费计算', calc_types: ['one'] },
	{ label: '造价工程师', value: 'cost', icon: '造', desc: '造价咨询 / 资产评估', calc_types: ['three', 'zcpg', 'cost_tool'] },
	{ label: '招标代理', value: 'bidding', icon: '招', desc: '招标代理费计算', calc_types: ['two'] },
	{ label: '建设单位', value: 'owner', icon: '建', desc: '前期咨询 / 概算独立费', calc_types: ['four', 'seven', 'eight', 'six', 'shuitu', 'jiaotong', 'jsqlx', 'ybf', 'ldaqwsps', 'dzzh', 'shwd', 'jn'] },
];

// ── 地区列表 ──
export const CALC_AREA = [
	{ label: '全国通用', value: 100 },
	{ label: '广东', value: 440000 },
	{ label: '河北', value: 130000 },
	{ label: '四川', value: 510000 },
	{ label: '山东', value: 370000 },
];

// ── 计算器注册表 ──
// calc_mode: 'local' = 纯前端引擎, 'api' = 后端API, 'component' = 独立组件（暂未迁移）
// schema: 仅 local/api 类型需要配置，component 类型由独立组件自行处理
export const CALC_REGISTRY = [

	// ========================================
	// 设计费计算
	// ========================================
	{
		id: 'zero',
		name: '全国通用设计费计算器',
		calc_type: 'zero',
		calc_group: '设计费计算',
		calc_area: 100,
		path: '/CalcZero',
		seo: { title: '通用设计费计算器', description: '工程设计费免费在线计算，依据国家工程勘察设计收费标准（计价格[2002]10号），输入工程费金额自动计算设计基准价，支持专业系数与折扣调整。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcZero.vue'),
	},
	{
		id: 'zero_gd_one',
		name: '广东省建筑装饰设计收费计算器',
		calc_type: 'zero',
		calc_group: '设计费计算',
		calc_area: 440000,
		path: '/CalcZeroGdOne',
		seo: { title: '广东建筑装饰设计费计算器', description: '广东省建筑装饰工程设计费免费计算，支持按工程造价或建筑面积两种方式计费，可调整专业类别、复杂程度系数，快速得出设计费参考值。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcZeroGdOne.vue'),
	},
	{
		id: 'zero_gd_two',
		name: '广东省市政工程设计费计算器',
		calc_type: 'zero',
		calc_group: '设计费计算',
		calc_area: 440000,
		path: '/CalcZeroGdTwo',
		seo: { title: '广东市政工程设计费计算器', description: '广东省市政工程设计费免费在线计算，覆盖道路、城市轨道、隧道、管线综合、交通工程五大类型，依据广东省地方标准自动匹配收费区间。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcZeroGdTwo.vue'),
	},
	{
		id: 'zero_gd_three',
		name: '广东省岩土工程设计收费计算器',
		calc_type: 'zero',
		calc_group: '设计费计算',
		calc_area: 440000,
		path: '/calcZeroGdThree',
		seo: { title: '广东岩土工程设计费计算器', description: '广东省岩土工程设计咨询费免费计算，依据粤价[2002]216号收费标准，按简单、中等、复杂三个等级自动计算咨询费用。' },
		calc_mode: 'component',
		component: () => import('@/views/calcZeroGdThree.vue'),
	},
	{
		id: 'zero_hb',
		name: '河北工程设计费计算器',
		calc_type: 'zero',
		calc_group: '设计费计算',
		calc_area: 130000,
		path: '/calcZeroHb',
		seo: { title: '河北工程设计费计算器', description: '河北省工程设计费免费在线计算，依据河北省地方收费标准，支持专业调整系数与附加费率，快速估算各类工程设计费。' },
		calc_mode: 'component',
		component: () => import('@/views/calcZeroHb.vue'),
	},

	// ========================================
	// 勘察费计算
	// ========================================
	{
		id: 'five',
		name: '通用工程勘察费计算器',
		calc_type: 'five',
		calc_group: '勘察费计算',
		calc_area: 100,
		path: '/CalcFive',
		seo: { title: '建设单位管理费计算器', description: '建设单位管理费免费在线计算，依据财政部相关规定，按建设项目总概算额自动计算建设期日常管理费用，满足工程概算编制需求。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcFive.vue'),
	},

	// ========================================
	// 监理费计算
	// ========================================
	{
		id: 'one',
		name: '通用监理费计算器',
		calc_type: 'one',
		calc_group: '监理费计算',
		calc_area: 100,
		path: '/CalcOne',
		seo: { title: '通用监理费计算器', description: '建设工程监理费免费在线计算，依据发改价格[2007]670号收费标准，输入工程概算投资额，自动计算监理费基准价及折后金额，结果即时呈现。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcOne.vue'),
	},
	{
		id: 'one_sichuan',
		name: '四川监理费计算器',
		calc_type: 'one',
		calc_group: '监理费计算',
		calc_area: 510000,
		path: '/CalcOneSichuan',
		seo: { title: '四川监理费计算器', description: '四川省建设工程监理费免费计算，依据四川省地方现行收费标准，支持房建、市政、交通等专业类别及施工阶段系数调整。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcOneSichuan.vue'),
	},
	{
		id: 'one_gd',
		name: '广东监理费计算器',
		calc_type: 'one',
		calc_group: '监理费计算',
		calc_area: 440000,
		path: '/CalcOneGd',
		seo: { title: '广东监理费计算器', description: '广东省建设工程监理费免费计算，依据粤价[2011]84号收费标准，支持房建、市政等多类工程，可自定义折率，结果即时呈现。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcOneGd.vue'),
	},
	{
		id: 'one_sd',
		name: '山东监理费计算器',
		calc_type: 'one',
		calc_group: '监理费计算',
		calc_area: 370000,
		path: '/CalcOneSd',
		seo: { title: '山东监理费计算器', description: '山东省建设工程监理费免费在线计算，依据山东省地方现行收费标准，支持房建、市政、交通等工程类型，快速得出监理费参考值。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcOneSd.vue'),
	},
	{
		id: 'one_hb',
		name: '河北监理费计算器',
		calc_type: 'one',
		calc_group: '监理费计算',
		calc_area: 130000,
		path: '/CalcOneHb',
		seo: { title: '河北监理费计算器', description: '河北省建设工程监理费免费在线计算，依据河北省地方收费标准，支持专业系数及折率灵活调整，秒出监理费计算结果。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcOneHb.vue'),
	},

	// ========================================
	// 招标代理费计算
	// ========================================
	{
		id: 'two',
		name: '通用招标代理费计算器',
		calc_type: 'two',
		calc_group: '招标代理费计算',
		calc_area: 100,
		path: '/CalcTwo',
		seo: { title: '招标代理费计算器', description: '招标代理费免费在线计算，依据国家发改委收费标准（计价格[2002]1980号），输入中标金额即得代理费，支持货物类、服务类、工程类三种项目类型。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcTwo.vue'),
	},
	{
		id: 'two_sd',
		name: '山东招标代理费计算器',
		calc_type: 'two',
		calc_group: '招标代理费计算',
		calc_area: 370000,
		path: '/CalcTwoSd',
		seo: { title: '山东招标代理费计算器', description: '山东省招标代理费免费在线计算，依据山东省地方现行收费标准，快速估算工程项目招标代理服务费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcTwoSd.vue'),
	},
	{
		id: 'two_hb',
		name: '河北招标代理费计算器',
		calc_type: 'two',
		calc_group: '招标代理费计算',
		calc_area: 130000,
		path: '/CalcTwoHb',
		seo: { title: '河北招标代理费计算器', description: '河北省招标代理费免费在线计算，依据河北省地方现行收费标准，快速估算工程项目招标代理服务费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcTwoHb.vue'),
	},

	// ========================================
	// 造价咨询费计算
	// ========================================
	{
		id: 'three',
		name: '通用造价咨询费计算器',
		calc_type: 'three',
		calc_group: '造价咨询费计算',
		calc_area: 100,
		path: '/CalcThree',
		seo: { title: '造价咨询费计算器', description: '工程造价咨询费免费在线计算，依据国家收费标准，输入工程概算投资额自动计算，支持全过程造价咨询、竣工结算审核等多种咨询类型。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcThree.vue'),
	},
	{
		id: 'three_sichuan',
		name: '四川造价咨询费计算器',
		calc_type: 'three',
		calc_group: '造价咨询费计算',
		calc_area: 510000,
		path: '/CalcThreeSichuan',
		seo: { title: '四川造价咨询费计算器', description: '四川省工程造价咨询费免费在线计算，依据四川省地方现行收费标准，快速估算投资估算、概算、预算、结算各阶段咨询费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcThreeSichuan.vue'),
	},

	// ========================================
	// 资产评估费计算
	// ========================================
	{
		id: 'zcpg',
		name: '通用资产评估费计算器',
		calc_type: 'zcpg',
		calc_group: '资产评估费计算',
		calc_area: 100,
		path: '/CalcZcpg',
		seo: { title: '资产评估费计算器', description: '资产评估费免费在线计算，依据中国资产评估协会收费参考标准，按评估对象价值额累进自动计算评估服务费，结果清晰展示各档次计算明细。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcZcpg.vue'),
	},

	// ========================================
	// 前期咨询费计算
	// ========================================
	{
		id: 'four',
		name: '通用建设项目前期工作咨询费计算器',
		calc_type: 'four',
		calc_group: '前期咨询费计算',
		calc_area: 100,
		path: '/CalcFour',
		seo: { title: '前期咨询费计算器', description: '建设项目前期工作咨询费免费计算，依据国家计委收费标准（计价格[1999]1283号），输入估算总投资自动计算项目建议书、可研报告、评估等咨询费。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcFour.vue'),
	},
	{
		id: 'four_sichuan',
		name: '四川建设项目前期工作咨询费计算器',
		calc_type: 'four',
		calc_group: '前期咨询费计算',
		calc_area: 510000,
		path: '/CalcFourSichuan',
		seo: { title: '四川前期咨询费计算器', description: '四川省建设项目前期工作咨询费免费计算，依据四川省地方收费标准，快速估算项目建议书、可行性研究报告、项目评估等各阶段咨询费。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcFourSichuan.vue'),
	},

	// ========================================
	// 概算独立费计算
	// ========================================
	{
		id: 'seven',
		name: '建设单位管理费',
		calc_type: 'seven',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcSeven',
		seo: { title: '建设单位管理费计算器', description: '建设单位管理费免费在线计算，依据财政部相关规定，按建设项目总概算额自动计算建设期日常管理费用，满足工程概算编制需求。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcSeven.vue'),
	},
	{
		id: 'six',
		name: '环境影响评价费计算器',
		calc_type: 'six',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcSix',
		seo: { title: '工程勘察费计算器', description: '工程勘察费免费在线计算，依据国家工程勘察收费标准（计价格[2002]10号），支持岩土勘察、工程测量等类型，实物工作量与技术工作费自动分项计算。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcSix.vue'),
	},
	{
		id: 'eight',
		name: '工程保险费计算器',
		calc_type: 'eight',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcEight',
		seo: { title: '工程保险费计算器', description: '工程保险费免费在线计算，支持建筑工程一切险和安装工程一切险，输入建安工程造价自动按费率计算保险费，满足工程概算编制要求。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcEight.vue'),
	},
	{
		id: 'shuitu',
		name: '水土保持费计算器',
		calc_type: 'shuitu',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcShuitu',
		seo: { title: '水土保持费计算器', description: '水土保持费免费在线计算，依据水利部水保监[2005]22号标准，支持方案编制费、水保监测费、水保设施验收费三类费用一键计算。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcShuitu.vue'),
	},
	{
		id: 'jiaotong',
		name: '交通影响评价费',
		calc_type: 'jiaotong',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcJiaotong',
		seo: { title: '交通影响评价费计算器', description: '交通影响评价费免费在线计算，依据行业收费参考标准，按建设项目建筑规模或用地面积自动估算交评报告编制费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcJiaotong.vue'),
	},
	{
		id: 'jsqlx',
		name: '建设期利息费计算器',
		calc_type: 'jsqlx',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcJsqlx',
		seo: { title: '建设期利息计算器', description: '建设期贷款利息免费在线计算，输入贷款总额、年利率及建设年限，自动按年分期累计计算建设期利息，结果逐年明细列示，满足概算利息计算要求。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcJsqlx.vue'),
	},
	{
		id: 'ybf',
		name: '预备费计算器',
		calc_type: 'ybf',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcYbf',
		seo: { title: '预备费计算器', description: '工程预备费免费在线计算，含基本预备费与价差预备费两项，输入工程费用及预备费率自动计算，结果符合国家概算编制规范要求。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcYbf.vue'),
	},
	{
		id: 'ldaqwsps',
		name: '劳动安全卫生评审费计算器',
		calc_type: 'ldaqwsps',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcLdaqwsps',
		seo: { title: '劳动安全卫生评审费计算器', description: '劳动安全卫生评审费免费在线计算，依据行业收费参考标准，按建设项目总投资规模自动估算安全预评价及验收评审费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcLdaqwsps.vue'),
	},
	{
		id: 'dzzh',
		name: '地质灾害危险性评估费计算器',
		calc_type: 'dzzh',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcDzzh',
		seo: { title: '地质灾害评估费计算器', description: '地质灾害危险性评估费免费在线计算，依据行业收费参考标准，支持一级、二级、三级评估等级，按评估面积自动估算评估服务费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcDzzh.vue'),
	},
	{
		id: 'shwd',
		name: '社会稳定风险评估费计算器',
		calc_type: 'shwd',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcShwd',
		seo: { title: '社会稳定风险评估费计算器', description: '社会稳定风险评估费免费在线计算，依据行业收费参考标准，按建设项目总投资规模和评估报告级别自动估算评估服务费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcShwd.vue'),
	},
	{
		id: 'jn',
		name: '节能评估费计算器',
		calc_type: 'jn',
		calc_group: '概算独立费计算',
		calc_area: 100,
		path: '/CalcJn',
		seo: { title: '节能评估费计算器', description: '节能评估费免费在线计算，依据行业收费参考标准，按项目投资规模自动估算节能评估服务费用。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcShwd.vue'), // 注意：原calc_list_new.js中此条path指向CalcShwd，暂保留
	},

	// ========================================
	// 换算工具（纯前端型）
	// ========================================
	{
		id: 'vat',
		name: '增值税价格换算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcVAT',
		seo: { title: '增值税价格换算工具', description: '建筑工程增值税价格换算工具，支持9%/6%/3%税率，含税价与不含税价一键互转，快速计算税额，适用于工程造价、招标报价、结算审核等场景。' },
		calc_mode: 'local',
		engine: () => import('../engine/vat'),
		schema: {
			inputs: [
				{ key: 'tax_rate', label: '增值税率', type: 'select', default: 9,
					options: [{ label: '9%（建筑工程）', value: 9 }, { label: '6%（服务类）', value: 6 }, { label: '3%（小规模纳税人）', value: 3 }] },
				{ key: 'direction', label: '换算方向', type: 'tab-switch', default: 'to_exclude',
					options: [{ label: '含税→不含税', value: 'to_exclude' }, { label: '不含税→含税', value: 'to_include' }] },
				{ key: 'amount', label: '金额', type: 'number', unit: '元', placeholder: '请输入金额' },
			],
			results: [
				{ key: 'original', label: '原金额', unit: '元' },
				{ key: 'main', label: '换算结果', highlight: true, unit: '元' },
				{ key: 'tax', label: '税额', unit: '元' },
				{ key: 'rate', label: '适用税率' },
			],
			formula: [
				'不含税金额 = 含税金额 ÷ (1 + 税率)',
				'含税金额 = 不含税金额 × (1 + 税率)',
				'税额 = 不含税金额 × 税率',
			],
			seo_sections: [
				{ title: '建筑工程增值税换算说明', content: '建筑工程行业增值税率为 <strong>9%</strong>，适用于提供建筑服务的一般纳税人企业。小规模纳税人适用 <strong>3%</strong> 征收率。造价咨询、监理等服务类企业适用 <strong>6%</strong> 税率。' },
				{ title: '含税价与不含税价换算公式', content: '<strong>含税价转不含税价：</strong>不含税金额 = 含税金额 ÷ (1 + 税率)<br><strong>不含税价转含税价：</strong>含税金额 = 不含税金额 × (1 + 税率)<br><strong>税额计算：</strong>税额 = 不含税金额 × 税率' },
				{ title: '常见应用场景', content: '1. <strong>招标清单报价</strong>：合同价格通常为含税价，投标报价分析时需换算为不含税价比较。<br>2. <strong>造价成果文件</strong>：工程量清单计价中，综合单价包含增值税进项税，出具报告时需明确含税/不含税口径。<br>3. <strong>结算审核</strong>：审核付款申请时核对发票金额与不含税金额是否对应。' },
			],
		},
	},
	{
		id: 'audit_rate',
		name: '审减率计算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcAuditRate',
		seo: { title: '审减率计算工具', description: '工程结算审减率免费在线计算，输入送审金额与审定金额自动得出审减额和审减率，支持多项目批量汇总，是造价工程师结算审核必备工具。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcAuditRate.vue'),
	},
	{
		id: 'quality_bond',
		name: '质量保证金计算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcQualityBond',
		seo: { title: '质量保证金计算工具', description: '建设工程质量保证金（质保金）免费在线计算，按合同结算金额自动计算扣留金额，支持返还时间节点提示，依据建质〔2017〕138号最新规定。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcQualityBond.vue'),
	},
	{
		id: 'provisional',
		name: '暂列金额计算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcProvisional',
		seo: { title: '暂列金额计算工具', description: '暂列金额免费在线计算，支持按比例快速估算和分项明细汇总两种方式，适用于工程量清单编制、招标控制价编制等场景。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcProvisional.vue'),
	},
	{
		id: 'price_adjust',
		name: '工程价款调整计算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcPriceAdjust',
		seo: { title: '工程价款调整计算工具', description: '工程价款调整免费在线计算，输入基期价格和现行价格自动计算调整额，支持风险幅度设置，适用于材料价格波动引起的合同价款调整。' },
		calc_mode: 'local',
		engine: () => import('../engine/priceAdjust'),
		schema: {
			inputs: [
				{ key: 'base_price', label: '基期价格', type: 'number', unit: '元', placeholder: '签约时或基期价格' },
				{ key: 'current_price', label: '现行价格', type: 'number', unit: '元', placeholder: '施工期实际价格' },
				{ key: 'quantity', label: '工程数量', type: 'number', default: '1', placeholder: '请输入数量' },
				{ key: 'risk_range', label: '风险幅度', type: 'select', default: 5,
					options: [{ label: '5%（常用）', value: 5 }, { label: '3%', value: 3 }, { label: '8%', value: 8 }, { label: '10%', value: 10 }, { label: '不扣风险', value: 0 }] },
			],
			results: [
				{ key: 'base_price', label: '基期价格', unit: '元' },
				{ key: 'current_price', label: '现行价格', unit: '元' },
				{ key: 'wave', label: '价格波动' },
				{ key: 'risk_range', label: '风险幅度' },
				{ key: 'adjustable', label: '是否调价' },
				{ key: 'amount', label: '价款调整额', highlight: true, unit: '元' },
			],
			seo_sections: [
				{ title: '什么是工程价款调整？', content: '工程价款调整是指施工期间因<strong>法律法规变化、市场价格波动</strong>等原因，按合同约定的调价方法对合同价款进行调整。常见调价方式包括造价指数法、价格信息法、实际价格法等。' },
				{ title: '价格波动调价规则', content: '合同一般约定<strong>风险幅度</strong>（通常3%~5%），价格波动在幅度内由承包人承担，超出部分由发包人承担。<br><strong>上涨调整：</strong>调整额 = (现价 − 基价×(1+风险幅度%)) × 数量<br><strong>下跌调整：</strong>调整额 = (现价 − 基价×(1−风险幅度%)) × 数量' },
			],
		},
	},
	{
		id: 'regulatory_fee',
		name: '规费计算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcRegulatoryFee',
		seo: { title: '规费计算工具', description: '工程规费免费在线计算，支持社保和公积金分项费率自动匹配，内置广东、四川、山东、河北等省份费率，输入人工费一键计算。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcRegulatoryFee.vue'),
	},
	{
		id: 'unit_convert',
		name: '工程量单位换算',
		calc_type: 'cost_tool',
		calc_group: '换算工具',
		calc_area: 100,
		path: '/CalcUnitConvert',
		seo: { title: '工程量单位换算工具', description: '工程量单位换算工具，支持长度/面积/体积/重量多维度换算，面积按厚度换体积，适用于工程量清单编制和造价计算中的单位转换。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcUnitConvert.vue'),
	},

	// ========================================
	// 结算工具（纯前端型）
	// ========================================
	{
		id: 'progress_payment',
		name: '工程进度款计算',
		calc_type: 'cost_tool',
		calc_group: '结算工具',
		calc_area: 100,
		path: '/CalcProgressPayment',
		seo: { title: '工程进度款计算工具', description: '工程进度款免费在线计算，输入累计完成产值自动计算应付进度款，支持付款比例、预付款扣回、质保金扣留，是造价工程师进度款审核必备工具。' },
		calc_mode: 'local',
		engine: () => import('../engine/progressPayment'),
		schema: {
			inputs: [
				{ key: 'contract_price', label: '合同总价', type: 'number', unit: '万元', placeholder: '请输入合同总价' },
				{ key: 'completed_value', label: '累计完成产值', type: 'number', unit: '万元', placeholder: '累计已完成工程价值' },
				{ key: 'pay_rate', label: '付款比例', type: 'select', default: 80,
					options: [{ label: '80%（常用）', value: 80 }, { label: '85%', value: 85 }, { label: '75%', value: 75 }, { label: '70%', value: 70 }, { label: '90%', value: 90 }] },
				{ key: 'paid_amount', label: '已付进度款', type: 'number', unit: '万元', placeholder: '之前已支付的进度款（可选）' },
				{ key: 'prepaid_deduct', label: '预付款扣回', type: 'number', unit: '万元', placeholder: '本期应扣回预付款（可选）' },
				{ key: 'deduct_bond', label: '扣质保金', type: 'switch', default: false },
				{ key: 'bond_rate', label: '质保金比例', type: 'select', default: 3,
					options: [{ label: '3%', value: 3 }, { label: '2%', value: 2 }, { label: '5%', value: 5 }],
					condition: { key: 'deduct_bond', value: true } },
			],
			results: [
				{ key: 'contract_price', label: '合同总价', unit: '万元' },
				{ key: 'completed_value', label: '累计完成产值', unit: '万元' },
				{ key: 'progress', label: '完成比例' },
				{ key: 'total', label: '应付总额', unit: '万元' },
				{ key: 'paid', label: '已付进度款', unit: '万元' },
				{ key: 'prepaid_deduct', label: '预付款扣回', unit: '万元' },
				{ key: 'bond', label: '质保金扣留', unit: '万元' },
				{ key: 'pay', label: '本次应付', highlight: true, unit: '万元' },
			],
			seo_sections: [
				{ title: '什么是工程进度款？', content: '工程进度款是发包人根据合同约定，按<strong>工程形象进度或时间节点</strong>，分期向承包人支付的工程价款。进度款支付是工程合同履行的核心环节，直接关系到施工方现金流和项目推进。' },
				{ title: '进度款计算方法', content: '<strong>本次应付进度款 = 累计完成产值 × 付款比例 − 已付进度款 − 预付款扣回 − 质保金</strong><br>付款比例一般为 <strong>70%~85%</strong>，剩余部分在竣工结算后支付（扣除质保金）。' },
			],
		},
	},
	{
		id: 'deduct_point',
		name: '预付款起扣点计算',
		calc_type: 'cost_tool',
		calc_group: '结算工具',
		calc_area: 100,
		path: '/CalcDeductPoint',
		seo: { title: '预付款起扣点计算工具', description: '预付款起扣点免费在线计算，输入合同总价和预付款金额自动计算起扣点及扣回进度，适用于工程进度款支付与预付款扣回管理。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcDeductPoint.vue'),
	},
	{
		id: 'delay_penalty',
		name: '误期违约金计算',
		calc_type: 'cost_tool',
		calc_group: '结算工具',
		calc_area: 100,
		path: '/CalcDelayPenalty',
		seo: { title: '误期违约金计算工具', description: '误期违约金免费在线计算，输入合同总价和延误天数自动计算违约金，支持自定义日违约金比例和违约金上限，适用于工程合同违约金核算。' },
		calc_mode: 'local',
		engine: () => import('../engine/delayPenalty'),
		schema: {
			inputs: [
				{ key: 'contract_price', label: '合同总价', type: 'number', unit: '万元', placeholder: '请输入合同总价' },
				{ key: 'delay_days', label: '延误天数', type: 'number', unit: '天', placeholder: '实际延误天数' },
				{ key: 'daily_rate', label: '日违约金比例', type: 'select', default: 0.1,
					options: [{ label: '0.1‰（常用）', value: 0.1 }, { label: '0.05‰', value: 0.05 }, { label: '0.2‰', value: 0.2 }, { label: '0.3‰', value: 0.3 }, { label: '0.5‰', value: 0.5 }] },
				{ key: 'cap_rate', label: '违约金上限', type: 'select', default: 5,
					options: [{ label: '合同价5%（常用）', value: 5 }, { label: '3%', value: 3 }, { label: '10%', value: 10 }, { label: '不设上限', value: 0 }] },
			],
			results: [
				{ key: 'contract_price', label: '合同总价', unit: '万元' },
				{ key: 'delay_days', label: '延误天数' },
				{ key: 'daily', label: '日违约金', unit: '万元/天' },
				{ key: 'calc', label: '计算违约金', unit: '万元' },
				{ key: 'cap', label: '违约金上限', unit: '万元' },
				{ key: 'final', label: '实际违约金', highlight: true, unit: '万元' },
			],
			seo_sections: [
				{ title: '什么是误期违约金？', content: '误期违约金是承包人未按合同约定的竣工日期完工，<strong>每延误一天按合同总价的一定比例向发包人支付的违约金</strong>。日违约金比例一般为合同总价的 0.05‰～0.5‰，累计不超过合同总价的 3%～5%。' },
				{ title: '误期违约金计算公式', content: '<strong>日违约金 = 合同总价 × 日违约金比例(‰)</strong><br><strong>违约金总额 = 日违约金 × 延误天数</strong>（不超过合同约定的违约金上限）' },
			],
		},
	},
	{
		id: 'claim',
		name: '索赔费用计算',
		calc_type: 'cost_tool',
		calc_group: '结算工具',
		calc_area: 100,
		path: '/CalcClaim',
		seo: { title: '索赔费用计算工具', description: '工程索赔费用免费在线计算，支持人工费、机械费、材料费分项填写，自动计算管理费和利润，适用于工期延误、工程变更等索赔场景。' },
		calc_mode: 'local',
		engine: () => import('../engine/claim'),
		schema: {
			inputs: [
				{ key: 'claim_type', label: '索赔类型', type: 'select', default: 'delay',
					options: [{ label: '工期延误索赔', value: 'delay' }, { label: '工程变更索赔', value: 'change' }, { label: '加速施工索赔', value: 'accelerate' }, { label: '不可抗力索赔', value: 'force' }] },
				{ key: 'labor_days', label: '人工工日', type: 'number', unit: '工日', placeholder: '增加的工日数' },
				{ key: 'labor_price', label: '人工单价', type: 'number', unit: '元/工日', default: '200', placeholder: '元/工日' },
				{ key: 'machine_days', label: '机械台班', type: 'number', unit: '台班', placeholder: '增加的台班数' },
				{ key: 'machine_price', label: '台班单价', type: 'number', unit: '元/台班', placeholder: '元/台班' },
				{ key: 'material_cost', label: '材料费合计', type: 'number', unit: '元', placeholder: '增加的材料费' },
				{ key: 'mgmt_rate', label: '管理费率', type: 'select', default: 5,
					options: [{ label: '5%', value: 5 }, { label: '8%', value: 8 }, { label: '10%', value: 10 }, { label: '不计算', value: 0 }] },
				{ key: 'profit_rate', label: '利润率', type: 'select', default: 3,
					options: [{ label: '3%', value: 3 }, { label: '5%', value: 5 }, { label: '7%', value: 7 }, { label: '不计算', value: 0 }] },
			],
			results: [
				{ key: 'labor', label: '人工费', unit: '元' },
				{ key: 'machine', label: '机械费', unit: '元' },
				{ key: 'material', label: '材料费', unit: '元' },
				{ key: 'direct', label: '直接费小计', unit: '元' },
				{ key: 'mgmt', label: '管理费', unit: '元' },
				{ key: 'profit', label: '利润', unit: '元' },
				{ key: 'total', label: '索赔总额', highlight: true, unit: '元' },
			],
			seo_sections: [
				{ title: '什么是工程索赔？', content: '工程索赔是合同履行中，当事人一方因对方不履行或未能正确履行合同，或由于其他非自身因素受到损失，<strong>向对方提出的经济补偿要求</strong>。索赔是合同赋予的合法权利。' },
				{ title: '索赔费用构成', content: '<strong>人工费：</strong>增加工日 × 人工单价<br><strong>机械费：</strong>增加台班 × 台班单价<br><strong>材料费：</strong>因索赔事件增加的材料消耗<br><strong>管理费：</strong>直接费 × 管理费率<br><strong>利润：</strong>（直接费 + 管理费）× 利润率' },
			],
		},
	},

	// ========================================
	// 速查工具（纯前端型）
	// ========================================
	{
		id: 'safety_fee',
		name: '安全文明施工费率速查',
		calc_type: 'cost_tool',
		calc_group: '速查工具',
		calc_area: 100,
		path: '/CalcSafetyFee',
		seo: { title: '安全文明施工费率速查', description: '安全文明施工费率速查工具，查询各省安全施工费、文明施工费、环境保护费、临时设施费费率，支持建筑、市政、安装、装饰工程类型筛选。' },
		calc_mode: 'component',
		component: () => import('@/views/CalcSafetyFee.vue'),
	},
];

/**
 * 获取用于 CalcPage 列表展示的计算器列表
 * 兼容旧的 calc_name/calc_type/calc_group/calc_area/calc_path 字段
 */
export function getCalcList() {
	return CALC_REGISTRY.map(item => ({
		calc_name: item.name,
		calc_type: item.calc_type,
		calc_group: item.calc_group,
		calc_area: item.calc_area,
		calc_path: item.path,
	}));
}
